import Level1_FlashingPictures from "../Activities/Visualisation/Level1_FlashingPictures";
import Intro_VisuallyCodedMovement from "../Activities/Coding/Intro_VisuallyCodedMovement";
import Level2_FlashingClapPatterns from "../Activities/Coding/Level2_FlashingClapPatterns";
import Level2_SoundCodes from "../Activities/Coding/Level2_SoundCodes";
import Level6_Arrows from "../Activities/Coding/Level6_Arrows";
import Level5_MemoryDots from "../Activities/Coding/Level5_MemoryDots";
import Level8_bdpandq from "../Activities/Coding/Level8_bdpandq";
import Level4_VisualSequence from "../Activities/Visualisation/Level4_VisualSequence";
import Level3_RememberingShapes from "../Activities/Visualisation/Level3_RememberingShapes";
import Level5_FlashingWords from "../Activities/Visualisation/Level5_FlashingWords";
import Level5_FlashingDotToDotPatterns from "../Activities/Visualisation/Level5_FlashingDotToDotPatterns";
import Level5_RememberingBlockPatterns from "../Activities/Visualisation/Level5_RememberingBlockPatterns";
import Level2_FindThePicture from "../Activities/Visualisation/Level2_FindThePicture";
import Level2_NamingPictures from "../Activities/EyeMovements/Level2_NamingPictures";
import Level5_LetterCharts from "../Activities/EyeMovements/Level5_LetterCharts";
import Level6_LetterCharts2 from "../Activities/EyeMovements/Level6_LetterCharts2";
import Level2_Pointing from "../Activities/Coding/Level2_Pointing";
import Level5_BallBounce from "../Activities/Coding/Level5_BallBounce";
import Level8_TheShortVowelSounds from "../Activities/Coding/Level8_TheShortVowelSound";
import Level6_FlashingWords2 from "../Activities/Visualisation/Level6_FlashingWords2";
import Level6_HalopinHands from "../Activities/Coding/Level6_HalopinHands";
import Level7_HalopinHands2 from "../Activities/Coding/Level7_HalopinHands2";
import Level6_SayMyName from "../Activities/Visualisation/Level6_SayMyName";
import Level8_FlippingandRotatingShapes from "../Activities/Visualisation/Level8_FlippingandRotatingShapes";
import Level7_DescribingPictures from "../Activities/Visualisation/Level7_DescribingPictures";
import Level7_LetterCharts3 from "../Activities/EyeMovements/Level7_LetterCharts3";
import Level4_CountingLetters from "../Activities/EyeMovements/Level4_CountingLetters";
import Level8_FindingLetters from "../Activities/EyeMovements/Level8_FindingLetters";
import Level7_SuperVision from "../Activities/BuildingBinocularity/Level7_SuperVision";
import Level1_FindTheShape from "../Activities/EyeMovements/Level1_FindTheShape";
import Level5_MemoryDotsPeg from "../Activities/VisuallyDirectedFineMotor/Level5_MemoryDotsPeg";
import Level2_Tangrams from "../Activities/Visualisation/Level2_Tangrams";
import Level5_Tangrams2 from "../Activities/Visualisation/Level5_Tangrams2";
import Level6_Mazes from "../Activities/VisuallyDirectedFineMotor/Level6_Mazes";
import Level3_FollowTheLine from "../Activities/VisuallyDirectedFineMotor/Level3_FollowTheLine";
import Level5_TrailBlazers from "../Activities/VisuallyDirectedFineMotor/Level5_TrailBlazers";

import Level6_MagicGlasses from "../Activities/BuildingBinocularity/Level6_MagicGlasses";
import Level5_FeedTheAnimals from "../Activities/BuildingBinocularity/Level5_FeedTheAnimals";
import Level4_DoubleVision from "../Activities/BuildingBinocularity/Level4_DoubleVision";
import Level4_3DPictures from "../Activities/BuildingBinocularity/Level4_3DPictures";
import Level1_AnimalShapes from "../Activities/VisuallyDirectedFineMotor/Level1_AnimalShapes";
import Level6_XRayVision from "../Activities/BuildingBinocularity/Level6_XRayVision";
import Level3_ShadowPuppets from "../Activities/VisuallyDirectedFineMotor/Level3_ShadowPuppets";
import Level7_Origrami from "../Activities/VisuallyDirectedFineMotor/Level7_Origami";
import Level4_VisualSequence2 from "../Activities/Visualisation/Level4_VisualSequence2";
import Level6_AdvancedTangrams from "../Activities/Visualisation/Level6_AdvancedTangrams";

import Level6_ShadowPuppetsExpert from "../Activities/VisuallyDirectedFineMotor/Level6_ShadowPuppetsExpert"

import Level7_AdvancedMazes from "../Activities/VisuallyDirectedFineMotor/Level7AdvancedMazes";
// Activity map: path → { component, extraProps }
const activityMap = {
  "/Coding/PictureCodes.pdf": { component: Intro_VisuallyCodedMovement },
  "/Coding/ClapPatterns.pdf": { component: Level2_FlashingClapPatterns },
  "/Coding/SoundCodes.pdf": { component: Level2_SoundCodes },
  "/Coding/Arrows.pdf": { component: Level6_Arrows },
  "/Coding/MemoryDots.pdf": { component: Level5_MemoryDots },
  "/Coding/bdpq.pdf": { component: Level8_bdpandq },

  "/Visualisation/FlashingPictures.pdf": { component: Level1_FlashingPictures },
  "/Visualisation/VisualSequence.pdf": { component: Level4_VisualSequence },
  "/Visualisation/FlashingShapes.pdf": { component: Level3_RememberingShapes },
  "/Visualisation/FlashingWords.pdf": { component: Level5_FlashingWords },
  "/Visualisation/FlashingDotPatterns.pdf": {
    component: Level5_FlashingDotToDotPatterns,
  },
  "/Visualisation/BlockPatterns.pdf": {
    component: Level5_RememberingBlockPatterns,
  },
  "/Visualisation/FindthePicture.pdf": { component: Level2_FindThePicture },

  "/EyeMovements/PictureMemory.pdf": { component: Level2_NamingPictures },
  "/EyeMovements/LetterLeapFrogCharts.pdf": { component: Level5_LetterCharts },
  "/EyeMovements/LetterLeapFrogSongs.pdf": { component: Level6_LetterCharts2 },
  "/EyeMovements/LetterLeapFrogTales.pdf": { component: Level7_LetterCharts3 },
  "/EyeMovements/CountingLetters&Words.pdf": { component: Level4_CountingLetters },
  "/EyeMovements/FindingLetters.pdf": { component: Level8_FindingLetters },
  "/EyeMovements/KoalaCopy.pdf": { component: Level1_FindTheShape },

  "/Coding/Pointing.pdf": { component: Level2_Pointing },
  "/Coding/BallBounce.pdf": { component: Level5_BallBounce },
  "/Coding/LookintheMiddle.pdf": { component: Level8_TheShortVowelSounds },
  "/Coding/HalopinHands.pdf": { component: Level6_HalopinHands },
  "/Coding/HalopinHands2.pdf": { component: Level7_HalopinHands2 },

  "/Visualisation/WordTwins.pdf": { component: Level6_FlashingWords2 },
  "/Visualisation/SayMyName.pdf": { component: Level6_SayMyName },
  "/Visualisation/Flip&RotateShapes.pdf": {
    component: Level8_FlippingandRotatingShapes,
  },
  "/Visualisation/DescribingPictures.pdf": { component: Level7_DescribingPictures },

  "/BuildingBinocularity/SuperVision.pdf": { component: Level7_SuperVision },
  "/BuildingBinocularity/MagicGlasses.pdf": { component: Level6_MagicGlasses },
  "/BuildingBinocularity/FeedtheAnimals.pdf": { component: Level5_FeedTheAnimals },
  "/BuildingBinocularity/DoubleVision.pdf": { component: Level4_DoubleVision },
  "/BuildingBinocularity/3DPictures.pdf": { component: Level4_3DPictures },
  "/BuildingBinocularity/X-RayVision.pdf": {
    component: Level6_XRayVision,
    extraProps: ["changePdf"],
  },

  "/VisuallyDirectedFineMotor/PegboardMatch.pdf": { component: Level5_MemoryDotsPeg },
  "/VisuallyDirectedFineMotor/Mazes.pdf": {
    component: Level6_Mazes,
    extraProps: ["changePdf"],
  },
  "/VisuallyDirectedFineMotor/AdvancedMazes.pdf": {
    component: Level7_AdvancedMazes,
  },
  "/VisuallyDirectedFineMotor/FollowtheLine.pdf": {
    component: Level3_FollowTheLine,
  },
  "/VisuallyDirectedFineMotor/TrailBlazers.pdf": {
    component: Level5_TrailBlazers,
  },
  "/VisuallyDirectedFineMotor/AnimalShapes.pdf": {
    component: Level1_AnimalShapes,
    extraProps: ["changePdf"],
  },
  "/VisuallyDirectedFineMotor/ShadowPuppets.pdf": {
    component: Level3_ShadowPuppets,
    extraProps: ["changePdf"],
  },
  "/VisuallyDirectedFineMotor/ShadowPuppetsExpert.pdf": {
    component: Level6_ShadowPuppetsExpert,
    extraProps: ["changePdf"],
  },
  "/VisuallyDirectedFineMotor/Origami.pdf": {
    component: Level7_Origrami,
    extraProps: ["changePdf", "changeLU"],
  },

  "/Visualisation/Tangrams.pdf": {
    component: Level2_Tangrams,
    extraProps: ["changePdf"],
  },
  "/Visualisation/Tangrams2.pdf": {
    component: Level5_Tangrams2,
    extraProps: ["changePdf"],
  },
  
  "/Visualisation/VisualSequence2.pdf": {
    component: Level4_VisualSequence2,
    extraProps: ["changePdf", "changeLU"],
  },
  "/Visualisation/AdvancedTangrams.pdf": {
    component: Level6_AdvancedTangrams,
    extraProps: ["changePdf", "changeLU"],
  },
};

export default function ActivityHolder(props) {
  const entry = activityMap[props.activity];
  if (!entry) return null;

  const { component: ActivityComponent, extraProps = [] } = entry;

  // Always pass base props
  const baseProps = {
    open: props.expanded,
    openActivity: props.openActivity,
  };

  // Add only extra props if defined
  const extras = {};
  extraProps.forEach((key) => {
    if (props[key] !== undefined) extras[key] = props[key];
  });

  return (
    <div
      style={{
        height: "754px",
        border: "solid",
        borderRadius: "25px",
        borderColor: "transparent",
        padding: "15px",
      }}
    >
      <ActivityComponent {...baseProps} {...extras} />
    </div>
  );
}



